import { deleteSession, type SessionListItem } from "./api.js";
import { formatDateTime, deleteButton } from "./dom.js";

/** A past-session row: title + date/turn count, a resume action, and a delete
 *  button. Shared by the setup picker, the side menu, and the all-sessions page.
 *  `onResume` runs when the row is clicked. */
export function buildSessionRow(opts: {
  item: SessionListItem;
  onResume: () => void | Promise<void>;
}): HTMLLIElement {
  const { item, onResume } = opts;

  const li = document.createElement("li");
  li.className = "session-row";

  const open = document.createElement("button");
  open.type = "button";
  open.className = "session-item";
  const title = document.createElement("span");
  title.className = "session-title";
  title.textContent = item.title;
  const meta = document.createElement("span");
  meta.className = "session-meta-row";
  meta.textContent = `${formatDateTime(item.created_at)} · ${item.turns} message(s)`;
  open.append(title, meta);
  open.addEventListener("click", () => {
    open.disabled = true;
    void onResume();
  });

  const del = deleteButton({
    label: "Delete session",
    confirm: "Delete this session and its history? This cannot be undone.",
    row: li,
    action: () => deleteSession(item.id),
  });

  li.append(open, del);
  return li;
}
